import Navbar from '../features/Navbar'
import PromoBanner from '../features/PromoBanner'
import Hero from '../features/landing/Hero'
import ArvanceWay from '../features/landing/ArvanceWay'
import Gallery from '../features/landing/Gallery'
import Faq from '../features/landing/Faq'
import CallToAction from '../features/landing/CallToAction'
import Footer from '../features/landing/Footer'

const Home = () => {
  return (
    // Guard only: nothing should overflow (measured 360-1440). `clip`, not `hidden`, because a hidden
    // overflow would make this the scroll container and break the sticky navbar.
    <div className="w-full bg-brand-pageFill overflow-x-clip">
      <Navbar />
      <PromoBanner />
      <Hero />
      <ArvanceWay />
      <Gallery />
      <Faq />
      <CallToAction />
      <Footer />
    </div>
  )
}

export default Home
